/**
 * Loading silhouettes, one per shape of widget a card can hold. A widget's
 * loader should look like the thing that is about to replace it.
 */
export type GrWidgetLoaderVariant = 'line' | 'bar' | 'bar-horizontal' | 'donut' | 'metric';

/**
 * Ghost trend line drawn while a line/area widget loads. Authored in a
 * `0 0 100 40` viewBox that is stretched to the plot area, so the shape is
 * proportional and carries no intrinsic size.
 */
export const GR_WIDGET_LOADER_LINE_PATH =
  'M0 30 C 6 30 9 23 16 23 C 23 23 26 29 33 28 C 40 27 43 15 50 16 C 57 17 60 22 67 20 C 74 18 77 8 84 9 C 91 10 94 5 100 5';

/** Same trend line closed down to the baseline so it can carry the fade-out fill. */
export const GR_WIDGET_LOADER_AREA_PATH = `${GR_WIDGET_LOADER_LINE_PATH} L100 40 L0 40 Z`;

/** Percentage heights for the ghost columns of the `bar` variant. */
export const GR_WIDGET_LOADER_BAR_HEIGHTS: ReadonlyArray<number> = [54, 78, 44, 92, 66, 84, 58];

/** Percentage track fills for the ghost rows of the `bar-horizontal` variant. */
export const GR_WIDGET_LOADER_ROW_WIDTHS: ReadonlyArray<number> = [92, 68, 79, 54, 71];

export const GR_WIDGET_LOADER_AXIS_TICK_COUNT = 5;
export const GR_WIDGET_LOADER_LEGEND_COUNT = 3;
